// This file is generated by pnpm icons:generate. Do not edit.

import {Newskie as CanonicalNewskie} from './brands/Newskie'

/** @deprecated Import Newskie from `#/components/icons/brands/Newskie` instead. */
export const Newskie = CanonicalNewskie
